/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Remove_Custom_PricingInputs */

const en_admin_resource_form_remove_custom_pricing = /** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove custom pricing`)
};

const de_admin_resource_form_remove_custom_pricing = /** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuellen Preis für öffentliche Ressource entfernen`)
};

const es_admin_resource_form_remove_custom_pricing = /** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar precio personalizado del recurso público`)
};

const fr_admin_resource_form_remove_custom_pricing = /** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le prix personnalisé pour la ressource publique`)
};

const nl_admin_resource_form_remove_custom_pricing = /** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepaste prijzen verwijderen`)
};

/** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */
const it_admin_resource_form_remove_custom_pricing = en_admin_resource_form_remove_custom_pricing;

/** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */
const pt_br2_admin_resource_form_remove_custom_pricing = en_admin_resource_form_remove_custom_pricing;

/** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */
const pl_admin_resource_form_remove_custom_pricing = en_admin_resource_form_remove_custom_pricing;

/** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */
const hu_admin_resource_form_remove_custom_pricing = en_admin_resource_form_remove_custom_pricing;

/** @type {(inputs: Admin_Resource_Form_Remove_Custom_PricingInputs) => LocalizedString} */
const ro_admin_resource_form_remove_custom_pricing = en_admin_resource_form_remove_custom_pricing;

/**
* | output |
* | --- |
* | "Remove custom pricing" |
*
* @param {Admin_Resource_Form_Remove_Custom_PricingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_remove_custom_pricing = /** @type {((inputs?: Admin_Resource_Form_Remove_Custom_PricingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Remove_Custom_PricingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "de") return de_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "es") return es_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "fr") return fr_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "nl") return nl_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "it") return it_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "pl") return pl_admin_resource_form_remove_custom_pricing(inputs)
	if (locale === "hu") return hu_admin_resource_form_remove_custom_pricing(inputs)
	return ro_admin_resource_form_remove_custom_pricing(inputs)
});
export { admin_resource_form_remove_custom_pricing as "admin.resource_form.remove_custom_pricing" }